export default __webpack_public_path__ + "static/media/homestay_location2.7ffcbfbe.svg";